export const tutorialMenu = [
  {
    id: 1,
    title: '游戏基础',
    children: [
      {
        id: '1-1',
        title: '技能',
        path: '/tutorial/skills'
      },
      // {
      //   id: '1-2',
      //   title: '空间',
      //   path: '/tutorial/space'
      // },
      // {
      //   id: '1-3',
      //   title: '升级',
      //   path: '/tutorial/level-up'
      // },
      // {
      //   id: '1-4',
      //   title: '爵位',
      //   path: '/tutorial/nobility'
      // },
      // {
      //   id: '1-5',
      //   title: '背包',
      //   path: '/tutorial/backpack'
      // },
      // {
      //   id: '1-6',
      //   title: '常见问题',
      //   path: '/tutorial/faq'
      // }

    ]
  },
  {
    id: '1-7',
    title: '咖啡系统',
    children: [
      {
        id: '1-7-1',
        title: '基础介绍',
        path: '/tutorial/coffee-basic'
      }
    ]

  },
  // {
  //   id: 2,
  //   title: '活动副本',
  //   children: [
  //     {
  //       id: '2-1',
  //       title: '蚂蚁副本',
  //       path: '/tutorial/ant-instance'
  //     },
  //     {
  //       id: '2-2',
  //       title: '餐厅副本',
  //       path: '/tutorial/restaurant'
  //     },
  //     {
  //       id: '2-3',
  //       title: '春节活动',
  //       path: '/tutorial/spring-festival'
  //     },
  //     {
  //       id: '2-4',
  //       title: '寒假资源收集',
  //       path: '/tutorial/winter-resources'
  //     },
  //     {
  //       id: '2-5',
  //       title: '元宵节灯谜',
  //       path: '/tutorial/lantern-festival'
  //     },
  //     {
  //       id: '2-6',
  //       title: '新学期资源',
  //       path: '/tutorial/new-term'
  //     },
  //     {
  //       id: '2-7',
  //       title: '情人节活动',
  //       path: '/tutorial/valentines-day'
  //     },
  //     {
  //       id: '2-8',
  //       title: '迷幻森林副本',
  //       path: '/tutorial/fantasy-forest'
  //     }
  //   ]
  // }
] 